/**
 * CallControls — bottom bar with mute, video, end call, camera flip.
 */

import { type ReactNode } from 'react';

interface Props {
  audioEnabled: boolean;
  videoEnabled: boolean;
  isStreaming: boolean;
  onToggleAudio: () => void;
  onToggleVideo: () => void;
  onEndCall: () => void;
  onFlipCamera: () => void;
}

export function CallControls({
  audioEnabled,
  videoEnabled,
  isStreaming,
  onToggleAudio,
  onToggleVideo,
  onEndCall,
  onFlipCamera,
}: Props): ReactNode {
  return (
    <div className="call-controls">
      <button
        className={`control-btn ${audioEnabled ? '' : 'control-btn-off'}`}
        onClick={onToggleAudio}
        aria-label={audioEnabled ? 'Mute microphone' : 'Unmute microphone'}
      >
        <span className="control-icon">{audioEnabled ? '\uD83C\uDF99' : '\uD83D\uDD07'}</span>
        <span className="control-label">{audioEnabled ? 'Mute' : 'Unmuted'}</span>
      </button>

      <button
        className={`control-btn ${videoEnabled ? '' : 'control-btn-off'}`}
        onClick={onToggleVideo}
        aria-label={videoEnabled ? 'Turn off camera' : 'Turn on camera'}
      >
        <span className="control-icon">{videoEnabled ? '\uD83C\uDFA5' : '\uD83D\uDEAB'}</span>
        <span className="control-label">{videoEnabled ? 'Cam Off' : 'Cam On'}</span>
      </button>

      <button
        className="control-btn control-btn-flip"
        onClick={onFlipCamera}
        aria-label="Flip camera"
      >
        <span className="control-icon">\uD83D\uDD04</span>
        <span className="control-label">Flip</span>
      </button>

      <button
        className="control-btn control-btn-end"
        onClick={onEndCall}
        aria-label="End call"
      >
        <span className="control-icon">\u260E</span>
        <span className="control-label">{isStreaming ? 'End & Settle' : 'End'}</span>
      </button>
    </div>
  );
}
